export default __webpack_public_path__ + "static/media/refresh-cw-o.372fde65.svg";